<template>
  <div class="login">
    <el-card class="login-card-layout" header="易购">
      <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="100px" class="login-form-layout">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="loginForm.username"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="loginForm.password" type="password" show-password></el-input>
        </el-form-item>
        <el-form-item class="card-link">
          <el-link type="primary" @click="resetForm('loginForm')">重置</el-link>
        </el-form-item>
        <el-form-item class="login-button">
          <el-button type="primary" class="card-button" @click="submitForm('loginForm')">登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import Cookies from "js-cookie"

export default {
  name: "login",
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let loginRequestData = {
            username: this.loginForm.username,
            password: this.loginForm.password,
          };
          this.$api.login.login(loginRequestData).then((res) => {

            let userInfo = {
              username: res.username,
              userId: res.userId,
              token: res.token,
              role: res.role
            };

            Cookies.set('userInfo', userInfo, {expires: 7});
            this.$router.push('homepage');
          });
        } else {
          this.$message.error("验证失败");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style scoped>
.login {
  height: 100%;
  background: url("../assets/images/login-bg.png") bottom center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.login-card-layout {
  width: 30%;
  text-align: center;
  position: relative;
  top: -60px;
}

.logo {
  width: 200px;
  height: auto;
  margin-bottom: 20px;
  position: relative;
  top: -60px;
}

.card-link {
  text-align: right;
  margin-top: -20px;
  margin-bottom: 5px;
}

.login-button {
  margin-bottom: 5px;
}

.card-button {
  width: 100%;
}

</style>
